import { gql } from "@apollo/client";

export const CREATE_ONBOARDING_FORM = gql`
  mutation CreateOnboardingForm($input: OnboardingFormInput!) {
    createOnboardingForm(input: $input) {
      id
      studentFirstName
      guardianEmail
    }
  }
`;

export const UPDATE_ONBOARDING_FORM_PARTIAL = gql`
  mutation UpdateOnboardingFormPartial(
    $id: ID!
    $input: OnboardingFormUpdateInput!
  ) {
    updateOnboardingFormPartial(id: $id, input: $input) {
      id
      studentFirstName
      studentLastName
      studentEmail
      studentAge
      guardianName
      guardianEmail
      phoneNumber
      contactPreference
      emergencyContact
      emergencyContactNumber
      programInterested
      learningNeeds
      studentInterest
      selectedDates
      otherInterest
      scholarshipName
      scholarshipOther
      submittedFromURL
      userTimeZone
      profileCreated
      updatedTimestamp
    }
  }
`;
